module.exports = __webpack_public_path__ + "media/images/client/AdCatalog/search-empty-516bd9f3f9d989f8970cdb738aa5d147.svg";